import React, {useEffect, useMemo, useState} from 'react';
import {
  type MRT_ColumnFiltersState,
  type MRT_PaginationState,
  type MRT_SortingState,
  MRT_EditActionButtons,
  MaterialReactTable,
  createRow,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import {
  QueryClient,
} from '@tanstack/react-query';
import {Box, Button, CircularProgress} from '@mui/material';
import {useNavigate} from "react-router-dom";
import {useGetAllReportClientiVersore} from "./Services";
import {ReportClientiVersore} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ReportClientiVersoreExp from "./ReportClientiVersoreExp";
import ReportClientiVersoreJasper from "./ReportClientiVersoreJasper";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableRowsIcon from '@mui/icons-material/TableRows';
import {useTabSettings} from "../../common/Services";

interface ListaReportClientiVersoreProps {
  // propflgtemp: string;
}

// const VersOre = () => {
const ListaReportClientiVersore: React.FC<ListaReportClientiVersoreProps> = () => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});
  // const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([],);
  const [globalFilter, setGlobalFilter] = useState('');
  // const [sorting, setSorting] = useState<MRT_SortingState>([]);
  // const [pagination, setPagination] = useState<MRT_PaginationState>({pageIndex: 0, pageSize: 15, });

  const [isFilteredByTemp, setIsFilteredByTemp] = useState(false); // State to track if TEMP filter is applied

   const keyusername = localStorage.getItem('keyusername') || 'NN';

 const {  columnVisibility,  setColumnVisibility,  columnFilters,  setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings,} = useTabSettings('ListaReportClientiVersore', keyusername);


  // Add function to toggle TEMP filter

   const isAdmin = localStorage.getItem('isadmin');
   const storeCodDip = localStorage.getItem('coddip');
   const storeNomeDip = localStorage.getItem('nomedip');
   const storeCodCli = localStorage.getItem('keycodclifor') ?? '';
   const storeDitta = localStorage.getItem('keyidazienda') ?? '';

   // console.log('storeCodCli: ',storeCodCli)

   const navigate = useNavigate();

  const columns = useMemo<MRT_ColumnDef<ReportClientiVersore>[]>(
    () => [
    // {
    //     accessorKey: 'ditta',
    //     header: 'Ditta',
    //     size: 10,
    //     enableEditing: false,
    //     Cell: ({ cell }) => {
    //         return cell.getValue() === 2 ? "BS" : "IN4IT";
    //     },
    // },
    // {
    //     accessorKey: 'codcli',
    //     header: 'CodCli',
    //     size: 10,
    //     enableEditing: false,
    // },
    //
    //  {
    //     accessorKey: 'ragsoccli',
    //     header: 'Cliente',
    //     size: 10,
    //     enableEditing: false,
    // },

    {
          accessorKey: 'datareg',
          header: 'Data',
          enableEditing: true,
          filterVariant: "date-range",
          size: 20,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (typeof value === 'string' || typeof value === 'number') {
                  const date = new Date(value);
                  return date.toLocaleDateString('it-IT'); // Change 'it-IT' to your desired locale
              } else {
                  return 'Nessuna Data';
              }
          },
      },





    {
         accessorKey: 'desprog',
         header: 'Progetto',
         size: 10,
         enableEditing: false,
     },

    // {
    //     accessorKey: 'nrrel',
    //     header: 'NRREL',
    //     size: 10,
    //     enableEditing: false,
    // },


    // {
    //     accessorKey: 'variante',
    //     header: 'Rif.NRREL',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'opzione',
    //     header: 'Opzione',
    //     size: 20,
    //     enableEditing: true,
    // },

    // {
    //     accessorKey: 'oreord',
    //     header: 'OreOrd',
    //     size: 10,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'minord',
    //     header: 'MinOrd',
    //     size: 10,
    //     enableEditing: true,
    // },
    {
        accessorKey: 'ore',
        header: 'Ore',
        size: 5,
        enableEditing: true,
    },
    {
        accessorKey: 'nomedip',
        header: 'Operatore',
        size: 5,
        enableEditing: true,
    },

    // {
    //     accessorKey: 'codprog',
    //     header: 'CodProg',
    //     size: 20,
    //     enableEditing: true,
    // },
    {
    accessorKey: 'note',
    header: 'Note',
    size: 13,
    enableEditing: true,
    Cell: ({ cell }) => {
        const value = cell.getValue() as string;
        return (
            <span title={value}>
                {value.length > 150 ? `${value.substring(0, 150)}...` : value}
            </span>
            );
        },
    },

    // {
    //     accessorKey: 'note',
    //     header: 'Note',
    //     size: 20,
    //     enableEditing: true,
    // },


    // {
    //     accessorKey: 'codatt',
    //     header: 'CodAtt',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'codnodo',
    //     header: 'CodNodo',
    //     size: 10,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'datains',
    //     header: 'DataIns',
    //     size: 20,
    //     enableEditing: true,
    //     Cell: ({ cell }) => {
    //         const value = cell.getValue();
    //         if (typeof value === 'string' || typeof value === 'number') {
    //             const date = new Date(value);
    //             return date.toLocaleDateString('it-IT'); // Change 'it-IT' to your desired locale
    //         } else {
    //             // Handle unexpected value types
    //             return "Nessuna Data";
    //         }
    //     },
    // },
    // {
    //     accessorKey: 'desnodo',
    //     header: 'DesNodo',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'desatt',
    //     header: 'DesAtt',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'codagente',
    //     header: 'CodAgente',
    //     size: 10,
    //     enableEditing: true,
    // },

    // {
    //     accessorKey: 'nomeagente',
    //     header: 'NomeAgente',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'ref',
    //     header: 'Ref',
    //     size: 20,
    //     enableEditing: true,
    // },
    // {
    //     accessorKey: 'flgval',
    //     header: 'FlgVal',
    //     size: 10,
    //     enableEditing: true,
    // },

    ],
    [validationErrors],
  );

  //call READ hook
  const {  data: { results = [], count } = {} ,isError: isLoadingReportClientiVersoreError, isFetching: isFetchingReportClientiVersore, isLoading: isLoadingReportClientiVersore} = useGetAllReportClientiVersore(pagination,columnFilters,globalFilter,sorting);


  // const generateExcelData = () => {
  //   const data = results.map((repoclientiversore) => ({
  //         nrrel: repoclientiversore.nrrel || '',
  //         ditta: repoclientiversore.ditta || '',
  //         datareg: repoclientiversore.datareg || '',
  //         variante: repoclientiversore.variante || '',
  //         opzione: repoclientiversore.opzione || '',
  //         coddip: repoclientiversore.coddip || '',
  //         ore: repoclientiversore.ore || '',
  //         codprog: repoclientiversore.codprog || '',
  //         note: repoclientiversore.note || '',
  //         codatt: repoclientiversore.codatt || '',
  //         codnodo: repoclientiversore.codnodo || '',
  //         datains: repoclientiversore.datains || '',
  //         desnodo: repoclientiversore.desnodo || '',
  //         desatt: repoclientiversore.desatt || '',
  //         codagente: repoclientiversore.codagente || '',
  //         codcli: repoclientiversore.codcli || '',
  //         nomeagente: repoclientiversore.nomeagente || '',
  //         ref: repoclientiversore.ref || '',
  //         flgval: repoclientiversore.flgval || '',
  //         ragsoccli: repoclientiversore.ragsoccli || '',
  //         desditta: repoclientiversore.desditta || '',
  //         desprog: repoclientiversore.desprog || '',
  //
  //   }));
  //
  //   return data;
  // };

  const openExporterModal = () => {
    setIsDialogExporterOpen(true);
  };


  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

  // const dataStartingWithS = useMemo(() => results.filter(item => item.nrrel && item.nrrelstartsWith('S')), [results]);
  // const dataStartingWithC = useMemo(() => results.filter(item => item.nrrel && item.nrrel.startsWith('C')), [results]);


  const [isDialogReportClientiVersoreExpPDF, setIsDialogReportClientiVersorePDF] = useState(false);
  const [isDialogReportClientiVersoreExpXLS, setIsDialogReportClientiVersoreXLS] = useState(false);





  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },


    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)

    enableEditing: false,
    enableRowActions: false,
    enableColumnActions: false,

    /*
    muiPaginationProps: {
      disabled: isFetchingReportClientiVersore,
    },
    */

    //getRowId: (row) => row.id.toString(),

    // getRowId: (row) => (row.id ? row.id.toString() : ''),



    muiToolbarAlertBannerProps: isLoadingReportClientiVersoreError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),
    onColumnFiltersChange: (updater) => {
      const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
      setColumnFilters(newFilters);
      saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },
    //  renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
    //      <>
    //     <DialogTitle variant="h3">Crea Nuovo ReportClienti</DialogTitle>
    //     <DialogContent
    //        sx={{ width: '1000px'}}
    //     >
    //       {internalEditComponents} {/* or render custom edit components here */}
    //
    //     </DialogContent>
    //     <DialogActions>
    //       <MRT_EditActionButtons variant="text" table={table} row={row} />
    //     </DialogActions>
    //
    //    </>
    // ),


   // renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
   //    <>
   //      <DialogTitle variant="h3">Edit ReportClienti</DialogTitle>
   //      <DialogContent
   //        sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
   //      >
   //        {internalEditComponents} {/* or render custom edit components here */}
   //      </DialogContent>
   //      <DialogActions>
   //        <MRT_EditActionButtons variant="text" table={table} row={row} />
   //      </DialogActions>
   //    </>
   //  ),

    // renderRowActions: ({ row, table }) => (
    //   <Box sx={{ display: 'flex', gap: '0.20rem' }}>
    //
    //       {/* Show the button unless isAdmin is false and flgtemp is Y */}
    // {!(isAdmin === 'false' ) && (
    //   <>
    //
    //   </>
    // )}
    //
    // </Box>
    //
    //
    // ),




  renderTopToolbarCustomActions: ({ table }) => (

    <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
            // border: '2px solid red',
        }}
      >

      <Button onClick={() => setIsDialogExporterOpen(true)} startIcon={<FileDownloadIcon />} > EXPORT DATI </Button>
        {isDialogExporterOpen && (
            <ReportClientiVersoreExp
              pagination={pagination}
              columnFilters={columnFilters}
              globalFilter={globalFilter}
              sorting={sorting}
              onClose={() => setIsDialogExporterOpen(false)}
            />
          )}


          <Button onClick={() => setIsDialogReportClientiVersoreXLS(true)} startIcon={<TableRowsIcon />}>
            Report Ore Clienti XLS
          </Button>
          {isDialogReportClientiVersoreExpXLS && <ReportClientiVersoreJasper propditta={storeDitta} propcodcli={storeCodCli}   propformato="xlsx" onClose={() => setIsDialogReportClientiVersoreXLS(false)} />}

          <Button onClick={() => setIsDialogReportClientiVersorePDF(true)} startIcon={<PictureAsPdfIcon />}>
            Report Ore Clienti PDF
          </Button>
          {isDialogReportClientiVersoreExpPDF && <ReportClientiVersoreJasper propditta={storeDitta} propcodcli={storeCodCli}  propformato="pdf" onClose={() => setIsDialogReportClientiVersorePDF(false)} />}

   </Box>
   ),


    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
      isLoading: isLoadingReportClientiVersore,
      // isSaving: isCreatingReportClienti || isUpdatingReportClienti || isDeletingReportClienti,
      // isSaving:  isDeletingReportClienti,
      showAlertBanner: isLoadingReportClientiVersoreError,
      showProgressBars: isFetchingReportClientiVersore,

      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });

 // return (
 //
 //     <Box sx={{ mt: "60px" }}>
 //      {isLoadingReportClientiVersore ? (
 //        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "500px" }}>
 //          <CircularProgress size={80} />
 //        </Box>
 //      ) : (
 //        <MaterialReactTable table={table} />
 //      )}
 //    </Box>
 //
 //  );

 return (

     <Box sx={{ mt: "60px" }}>
        <MaterialReactTable table={table} />
    </Box>

  );




};


const queryClient = new QueryClient();

// const VersOreWithProviders = () => (
//   //Put this with your other react-query providers near root of your app
//   <QueryClientProvider client={queryClient}>
//     <VersOre />
//   </QueryClientProvider>
// );

export default ListaReportClientiVersore;

const validateRequired = (value: string) => !!value.length;
const validateRequiredNum = (value: number) => !!value.toString().length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );


